import {
  saveInfoPaxMonetary as saveInfoPax,
  getDataMoneTary as getInfoMonetary,
  openMonetaryOrder,
  confirmMonetaryCompensation,
  fetchStatusMonetary
} from '@/api/service'

const saveInfoPaxMonetary = (context, data) => {
  return saveInfoPax(data).then((response) => {
    return response
  })
}

const getDataMoneTary = (context, data) => {
  return getInfoMonetary(data).then((response) => {
    context.commit('INFO_PAX_MONETARY', response)
  })
}

const openMonetaryCompensationOrder = (context, request) => {
  return openMonetaryOrder(request).then((response) => {
    return response
  })
}

const confirmMonetary = (context, request) => {
  return confirmMonetaryCompensation(request).then((response) => {
    return response
  })
}

const statusMonetary = (context, request) => {
  return fetchStatusMonetary(request).then((response) => {
    return response
  })
}

export default {
  saveInfoPaxMonetary,
  getDataMoneTary,
  openMonetaryCompensationOrder,
  confirmMonetary,
  statusMonetary
}
